import { editDeviceCalibrateResultRequest, getDeviceCalibrateResultRequest } from "@/service/parameterConfiguration";
import { Button, Divider, Form, Input, InputNumber, message } from "antd";
import { useEffect, useState } from "react";

interface iProps {
    id: number | string,
    sn: number | string,
    refreshTrigger?: number,
    onRefreshAll?: () => void
}

const AxBsdCameraForm = (props: iProps) => {

    const { id, sn, refreshTrigger, onRefreshAll } = props
    const [form] = Form.useForm();
    const [isLoading, setIsLoading] = useState(false);
    const [hasSearch, setHasSearch] = useState(false);


    const updateForm = async () => {
        let _formValue = {};
        try {
            setIsLoading(true);
            const res = await getDeviceCalibrateResultRequest({ id, sn });
            const data = res.data?.data || {};

            const parseNumber = (v: any) => (v === null || v === undefined || v === '' ? undefined : Number(v));

            _formValue = {
                version: data.version,
                success: parseNumber(data.success),
                locationX: parseNumber(data.locationX),
                locationY: parseNumber(data.locationY),
                locationZ: parseNumber(data.locationZ),
                pitch: parseNumber(data.pitch),
                yaw: parseNumber(data.yaw),
                roll: parseNumber(data.roll),
                imgW: parseNumber(data.imgW),
                imgH: parseNumber(data.imgH),
                px: parseNumber(data.px),
                py: parseNumber(data.py),
                fx: parseNumber(data.fx),
                fy: parseNumber(data.fy),
                cx: parseNumber(data.cx),
                cy: parseNumber(data.cy),
                k1: parseNumber(data.k1),
                k2: parseNumber(data.k2),
                k3: parseNumber(data.k3),
                k4: parseNumber(data.k4),
                mountMode: parseNumber(data.mountMode),
                calibrationFieldVersion: parseNumber(data.calibrationFieldVersion),
                cameraModel: parseNumber(data.cameraModel),
                detectionMode: parseNumber(data.detectionMode),
                vehicleCoordOrigin: parseNumber(data.vehicleCoordOrigin),
                reserved: parseNumber(data.reserved),
                algorithmVersion: data.algorithmVersion,
                pcVersion: data.pcVersion,
                time: data.time,
            };
            setHasSearch(true);
        } catch (err) {
            console.error("err", err);
        } finally {
            setIsLoading(false);
            form.setFieldsValue(_formValue);
        }

    }
    useEffect(() => {
        updateForm();
    }, [id, sn, refreshTrigger]);


    const submitForm = async () => {
        try {
            setIsLoading(true);
            const values = await form.validateFields();
            const params = {
                id,
                ...values
            }
            const res = await editDeviceCalibrateResultRequest(params, sn);

            if (res.data.code === 0) {
                message.success('下发安行BSD相机标定结果成功');
                onRefreshAll?.();
            } else {
                message.error('下发安行BSD相机标定结果失败');
            }
        } catch (error) {
            console.error("submit failed:", error);
            message.error('下发安行BSD相机标定结果失败');
        } finally {
            setIsLoading(false);
        }
    }

    return <div>
        <Divider>安行BSD相机标定结果</Divider>
        <Form form={form} labelAlign="left" labelCol={{ span: 8, style: { whiteSpace: 'normal', overflowWrap: 'break-word' } }} wrapperCol={{ span: 14 }}>
            <Form.Item label="参数版本号" name="version" style={{ marginBottom: '20px' }}>
                <Input disabled={true} />
            </Form.Item>
            <Form.Item label="标定状态" name="success" style={{ marginBottom: '20px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="标定后位置x" name="locationX" style={{ marginBottom: '20px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="标定后位置y" name="locationY" style={{ marginBottom: '20px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="标定后位置z" name="locationZ" style={{ marginBottom: '20px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="标定后pitch" name="pitch" style={{ marginBottom: '20px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="标定后yaw" name="yaw" style={{ marginBottom: '20px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="标定后roll" name="roll" style={{ marginBottom: '20px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="imgW" name="imgW" style={{ marginBottom: '20px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="imgH" name="imgH" style={{ marginBottom: '20px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="px" name="px" style={{ marginBottom: '20px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="py" name="py" style={{ marginBottom: '20px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="fx" name="fx" style={{ marginBottom: '20px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="fy" name="fy" style={{ marginBottom: '20px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="cx" name="cx" style={{ marginBottom: '20px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="cy" name="cy" style={{ marginBottom: '20px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="k1" name="k1" style={{ marginBottom: '20px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="k2" name="k2" style={{ marginBottom: '20px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="k3" name="k3" style={{ marginBottom: '20px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="k4" name="k4" style={{ marginBottom: '20px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="mountMode" name="mountMode" style={{ marginBottom: '20px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="calibrationFieldVersion" name="calibrationFieldVersion" style={{ marginBottom: '20px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="cameraModel" name="cameraModel" style={{ marginBottom: '20px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="detectionMode" name="detectionMode" style={{ marginBottom: '20px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="vehicleCoordOrigin" name="vehicleCoordOrigin" style={{ marginBottom: '20px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="reserved" name="reserved" style={{ marginBottom: '20px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="algorithmVersion" name="algorithmVersion" style={{ marginBottom: '20px' }}>
                <Input disabled={true} />
            </Form.Item>
            <Form.Item label="pcVersion" name="pcVersion" style={{ marginBottom: '20px' }}>
                <Input disabled={true} />
            </Form.Item>
            <Form.Item label="time" name="time" style={{ marginBottom: '20px' }}>
                <Input disabled={true} />
            </Form.Item>
            <div style={{ textAlign: 'right' }}>
                <Button
                    type="primary"
                    disabled={!hasSearch}
                    loading={isLoading}
                    onClick={submitForm}
                >
                    下发安行BSD相机标定结果
                </Button>
            </div>
        </Form>
    </div>
};

export default AxBsdCameraForm;
